import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/logo-transparent.png';

const Logo = ({ size = 'normal', className = '', onClick, state }) => {
  const containerSizes = { small: 'h-9', normal: 'h-11', large: 'h-14' };
  const imageSizes = { small: 'h-9', normal: 'h-11', large: 'h-14' };

  return (
    <Link
      to="/"
      state={state}
      onClick={onClick}
      className={`group inline-flex min-w-0 items-center ${containerSizes[size]} ${className}`}
      style={{ textDecoration: 'none' }}
      aria-label="Salon home"
    >
      <img
        src={logoImage}
        alt=""
        className={`${imageSizes[size]} w-auto shrink-0 object-contain transition-transform duration-200 group-hover:scale-105`}
        aria-hidden="true"
      />
    </Link>
  );
};

export default Logo;
